export enum WhatIsNewModalActions {
    INSTALL_ANOTHER_DEVICE = 'installOnAnotherDevice',
    PASSWORD_MANAGER = 'configurePasswordManager',
    DIP = 'configureDIP',
    CLOSE = 'close',
    INVITE_FAMILY_MEMBER = 'inviteFamilyMember'
}

export enum WhatIsNewModalDataKeys {
    LOCAL_PROTECTION = 'localProtection',
    PASSWORD_MANAGER = 'passwordManager',
    PROTECT_MORE_DEVICES = 'protectMoreDevices',
    ROLES = 'roles',
    MULTIPLATFORM = 'multiplatform',
    CRYPTOMINING_PROTECTION = 'cryptominingProtection',
    DEVICE_OPTIMIZER = 'deviceOptimizer',
    ADDITIONAL_FEATURES_INDIVIDUAL = 'additionalFeaturesIndividual',
    ADDITIONAL_FEATURES_FAMILY = 'additionalFeaturesFamily',
    EXTRA_BENEFITS = 'extraBenefits',
    UPGRADE_DESCRIPTION = 'upgradeDescription',
    EXTRA_BENEFIT = 'extraBenefit',
    PORTOFOLIO = 'portofolio',
    ANTIVIRUS = 'antivirus',
    DASHBOARD_ROLES = 'dashboardRoles',
    EXTRA_BENEFITS_DIP = 'extraBenefitsDip',
    EXTRA_BENEFITS_DIP2 = 'extraBenefitsDip2',
    EXTRA_BENEFITS_DIP3 = 'extraBenefitsDip3',
    DATA_BREACH_DETECTION = 'dataBreachDetection',
    DARK_WEB_MONITORING = 'darkWebMonitoring',
    DIGITAL_FOOTPRINT_VISUALIZATION = 'digitalFootprintVisualization',
    BREACH_NOTIFICATIONS = 'breachNotifications',
    MULTIPLATFORM_NO_EXTRA = "MULTIPLATFORM_NO_EXTRA"
}

export type Icon = {
    type: string;
    value: string;
}

export type WhatIsNewModalIcons = {
    [key: string]: Icon;
}

export type WhatIsNewModalDataList = {
    [key: string]: string;
}

export type WhatIsNewBenefit = {
    icon?: Icon;
    title: string;
    description?: string;
    show?: (params: any) => boolean;
}

export type WhatIsNewModalButtonLabels = {
    [key in WhatIsNewModalActions]: string;
}

export interface WhatIsNewModalActionDetails {
    action: Function;
}

export type WhatIsNewModalActionsDetails = {
    [key in WhatIsNewModalActions]: Function;
}

export type WhatIsNewButton = {
    label: string;
    action: string;
    iconLeft?: Icon;
    iconRight?: Icon;
}

export type WhatIsNewButtons = {
    [key in WhatIsNewModalActions]: WhatIsNewButton
}

export type WhatIsNewScenarioDetails = {
    mandatoryParams?: Array<string>;
    optionalParams?: Array<string>;
    newBundleName?: (param?: any) => string;
    oldBundleName?: string;
    benefits: Array<WhatIsNewBenefit>;
    description: (param?: any) => string;
    description2?: string;
    description3?: string;
    button: (params?: any) => WhatIsNewButton;
}

export type WhatIsNewScenariosDetails = {
    [key: string]: {
        [key: string]: WhatIsNewScenarioDetails;
    };
}